import { Component, effect, Inject, inject, signal } from '@angular/core';
import { Store } from '@ngrx/store';
import { selectListsError } from '../../../../@store/orders/orders.selectors';
import {
  MAT_DIALOG_DATA,
  MatDialogActions,
  MatDialogContent,
  MatDialogRef,
  MatDialogTitle,
} from '@angular/material/dialog';
import { OrdersActions } from '../../../../@store/orders/orders.actions';
import { MatButton } from '@angular/material/button';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { MatIconModule } from '@angular/material/icon';
import { NgIf } from '@angular/common';

@Component({
  selector: 'ciwc-lists-delete',
  imports: [
    MatButton,
    MatDialogActions,
    MatDialogContent,
    MatDialogTitle,
    MatProgressSpinner,
    MatIconModule,
    NgIf,
  ],
  templateUrl: './lists-delete.component.html',
  styleUrl: './lists-delete.component.scss',
})
export class ListsDeleteComponent {
  private readonly store = inject(Store);
  readonly error = this.store.selectSignal(selectListsError);
  readonly lastAction = this.store.selectSignal((state) => state.orders.lastAction);
  isDeleting = signal(false);

  constructor(
    public dialogRef: MatDialogRef<ListsDeleteComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { listId: number; listName: string },
  ) {
    effect(() => {
      if (this.isDeleting()) {
        const error = this.error();
        if (error) {
          this.isDeleting.set(false);
        }
      }
    });

    effect(() => {
      const action = this.lastAction();
      if (action === 'Delete List Success' && this.isDeleting()) {
        this.isDeleting.set(false);
        this.dialogRef.close({
          success: true,
        });
      }
    });
  }

  onCancel(): void {
    this.dialogRef.close();
  }

  onConfirm(): void {
    this.isDeleting.set(true);
    this.store.dispatch(
      OrdersActions.deleteList({
        id: this.data.listId,
      }),
    );
  }
}
